import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import { prepareFilters } from '../../../components/Filters/request';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      ...item,
      key: item.id,
      select: { id: item.id, value: false },
      title: { id: item.id, name: item.name },
      status_data: { status: item.status, start_date: item.starts_at },
      offers_count: item.offers_count,
      offers_source: item.offers_source,
      date: { date_start: item.starts_at, date_end: item.ends_at },
      users_count: item.users_count,
      top_users: item.top_users,
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getLookbooks({ payload: { signal, filters, searchQ, curr_page, status } }) {
  try {

    const { sort } = prepareFilters(filters);

    const { data } = yield call(fetch, {
      api: api.lookbooks.list,
      params: {
        page: curr_page,
        ...(sort && { ordering: sort[0] }),
        ...(searchQ && { q: searchQ }),
        ...(status ? { status } : {})
      },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getLookbooksDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getLookbooksFailed,
      endpoint: api.lookbooks.list.url
    });
  }
}

export const getLookbooksSaga = takeEvery(types.GET_LOOKBOOKS_REQUEST, getLookbooks);